import analyticsService from "../AnalyticsService";

// Centralized Mixpanel/GA event helpers for the Nationwide flow.
// Naming: nw_<verb>_<object>. All events auto-include flow, app_version, screen, session_id.
// See docs/analytics-events.md for the full event reference.

const evt = (name, props = {}) => analyticsService.trackEvent(name, props);

export const track = {
  // page views
  pageViewed: (screen, props = {}) =>
    analyticsService.trackPageView(`nw_page_${screen}`, props),
  pageViewedUnknown: (pathname) =>
    analyticsService.trackPageView("nw_page_unknown", { pathname }),

  // activation (NationwideWelcome)
  activationOpened: (props) => evt("nw_activation_opened", props),
  activationExchangeSucceeded: (props) =>
    evt("nw_activation_exchange_succeeded", props),
  activationExchangeFailed: (props) =>
    evt("nw_activation_exchange_failed", props),
  activationBootstrapSucceeded: (props) =>
    evt("nw_activation_bootstrap_succeeded", props),
  activationBootstrapFailed: (props) =>
    evt("nw_activation_bootstrap_failed", props),
  activationContinueClicked: (props) =>
    evt("nw_activation_continue_clicked", props),

  // welcome
  welcomeContinueClicked: (props) => evt("nw_welcome_continue_clicked", props),
  welcomeSkipToVerificationClicked: (props) =>
    evt("nw_welcome_skip_to_verification_clicked", props),

  // verification
  verificationMethodShown: (props) => evt("nw_verification_method_shown", props),
  verificationMethodSelected: (props) =>
    evt("nw_verification_method_selected", props),
  emailLinkRequested: (props) => evt("nw_email_link_requested", props),
  emailLinkRequestFailed: (props) => evt("nw_email_link_request_failed", props),
  emailLinkCompleted: (props) => evt("nw_email_link_completed", props),
  googleSigninInitiated: (props) => evt("nw_google_signin_initiated", props),
  googleSigninSucceeded: (props) => evt("nw_google_signin_succeeded", props),
  googleSigninFailed: (props) => evt("nw_google_signin_failed", props),

  // alarm survey + flow transitions
  surveyStarted: (props) => evt("nw_survey_started", props),
  surveyQuestionAnswered: (props) => evt("nw_survey_question_answered", props),
  surveySubmitted: (props) => evt("nw_survey_submitted", props),
  surveyResponsesModalOpened: (props) =>
    evt("nw_survey_responses_modal_opened", props),
  alarmNoSystemAcknowledged: (props) =>
    evt("nw_alarm_no_system_acknowledged", props),
  alarmContinueToUploadClicked: (props) =>
    evt("nw_alarm_continue_to_upload_clicked", props),

  // document upload
  documentAdded: (props) => evt("nw_document_added", props),
  documentRemoved: (props) => evt("nw_document_removed", props),
  documentValidationFailed: (props) =>
    evt("nw_document_validation_failed", props),
  documentUploadStarted: (props) => evt("nw_document_upload_started", props),
  documentUploadSucceeded: (props) =>
    evt("nw_document_upload_succeeded", props),
  documentUploadFailed: (props) => evt("nw_document_upload_failed", props),
  checkinSubmitClicked: (props) => evt("nw_checkin_submit_clicked", props),
  checkinSubmitSucceeded: (props) => evt("nw_checkin_submit_succeeded", props),
  checkinSubmitFailed: (props) => evt("nw_checkin_submit_failed", props),

  // contact info
  contactVerifyClicked: (props) => evt("nw_contact_verify_clicked", props),
  contactSaveClicked: (props) => evt("nw_contact_save_clicked", props),

  // rewards summary
  rewardsViewed: (props) => evt("nw_rewards_viewed", props),
  rewardsBalanceModalOpened: (props) =>
    evt("nw_rewards_balance_modal_opened", props),
  payoutDetailsToggled: (props) => evt("nw_payout_details_toggled", props),
  buyerDetailsOpened: (props) => evt("nw_buyer_details_opened", props),
  claimDeniedNoBalance: (props) => evt("nw_claim_denied_no_balance", props),

  // rewards claim
  rewardsClaimViewed: (props) => evt("nw_rewards_claim_viewed", props),
  rewardProductSelected: (props) => evt("nw_reward_product_selected", props),
  rewardClaimInitiated: (props) => evt("nw_reward_claim_initiated", props),
  rewardClaimSucceeded: (props) => evt("nw_reward_claim_succeeded", props),
  rewardClaimFailed: (props) => evt("nw_reward_claim_failed", props),
  rewardDeliveryLinkClicked: (props) =>
    evt("nw_reward_delivery_link_clicked", props),
  rewardClaimDismissed: (props) => evt("nw_reward_claim_dismissed", props),

  // step machine
  stepCompleted: (props) => evt("nw_step_completed", props),

  // user-visible errors
  errorShown: (props) => evt("nw_error_shown", props),

  // identification
  identify: (userId, props) => analyticsService.identifyUser(userId, props),
  reset: () => analyticsService.resetUser(),

  // escape hatch for ad-hoc events that don't yet have a helper
  custom: (name, props) => evt(name, props),
};

export default track;
